import { createRoot } from 'react-dom/client';
import './i18n';
// import './index.css';
import './juristec-ui/styles/fonts/index.css';
import App from './components/App';
import Head from './components/Head';
import * as serviceWorker from './serviceWorker';

createRoot(document.getElementById('root')).render(
  <>
    <Head />
    <App />
  </>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
